import type { HdcReport } from "../../../../../ExperianPrivateResponse.types";
import { TrimesterVM, mapDebtEvolution } from "../mappers";
import { C, tabular, toneColor } from "../theme";
import { Card } from "../shared/Card";
import { Column, DataTable } from "../shared/DataTable";

const BAR_MAX_PX = 160;

const columns: Column<TrimesterVM>[] = [
  { key: "label", header: "Trimestre", align: "l", strong: true, render: (t) => t.label },
  { key: "quota", header: "Cuota", align: "r", render: (t) => t.quota },
  { key: "balance", header: "Saldo", align: "r", render: (t) => t.balance },
  {
    key: "delinquency",
    header: "Mora máx.",
    render: (t) => t.delinquency,
    cellStyle: (t) => ({ color: toneColor(t.delinquencyTone), fontWeight: 600 }),
  },
  {
    key: "rating",
    header: "Calificación",
    render: (t) => t.rating,
    cellStyle: () => ({ fontWeight: 700 }),
  },
  { key: "use", header: "% uso", align: "r", render: (t) => t.use },
  { key: "opened", header: "Abiertas", render: (t) => t.opened },
  { key: "closed", header: "Cerradas", render: (t) => t.closed },
  { key: "score", header: "Score", render: (t) => t.score },
];

export const EvolucionTab = ({ report }: { report: HdcReport }) => {
  const trimesters = mapDebtEvolution(report);
  const max = Math.max(0, ...trimesters.map((t) => t.balanceRaw ?? 0));
  return (
    <Card
      title="Evolución de la deuda por trimestre"
      aside="Saldo total · miles de COP"
      style={{ padding: "18px 20px 12px", gap: 16 }}
    >
      {/* Bars repeat the table below, so they are hidden from assistive tech. */}
      <div aria-hidden="true" style={{ overflowX: "auto" }}>
        <div
          style={{
            minWidth: Math.max(trimesters.length * 80, 320),
            display: "grid",
            gridTemplateColumns: `repeat(${trimesters.length}, minmax(0, 1fr))`,
            gap: 14,
            alignItems: "end",
          }}
        >
          {trimesters.map((t, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                gap: 6,
              }}
            >
              <span
                style={{ ...tabular, fontSize: 11, textAlign: "center", color: C.text }}
              >
                {t.balance}
              </span>
              <div
                style={{
                  height:
                    max > 0 && t.balanceRaw !== null
                      ? Math.max(2, Math.round((t.balanceRaw / max) * BAR_MAX_PX))
                      : 2,
                  borderRadius: "4px 4px 0 0",
                  background:
                    i === trimesters.length - 1 ? C.ok : "rgba(111,214,201,0.45)",
                }}
              />
              <span
                style={{
                  fontSize: 12,
                  textAlign: "center",
                  fontWeight: 600,
                  color: C.white,
                }}
              >
                {t.label}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div style={{ margin: "0 -20px" }}>
        <DataTable
          caption="Evolución de la deuda por trimestre, miles de COP"
          columns={columns}
          rows={trimesters}
        />
      </div>
    </Card>
  );
};
